import { render, staticRenderFns } from "./JeepayTextUp.vue?vue&type=template&id=4708ca2b&scoped=true"
import script from "./JeepayTextUp.vue?vue&type=script&lang=js"
export * from "./JeepayTextUp.vue?vue&type=script&lang=js"
import style0 from "./JeepayTextUp.vue?vue&type=style&index=0&id=4708ca2b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4708ca2b",
  null
  
)

export default component.exports